// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HC3z","field":"styles_field__2d8I0","fieldCol":"styles_fieldCol__NjD5R","diffCol":"styles_diffCol__1hd0P","diff":"styles_diff__2UIlK"};